import dynamic from 'next/dynamic';
import styles from './index.module.scss';
import FirstKv from './components/FirstKv';
import HeaderSticky from './components/HeaderSticky';
import { useGlobal } from '@/utils/useGlobal';

const PageCom = dynamic(() => import('@/components/productSmart/powerstream/detail/indexDynamic'), {
    ssr: true,
});

export default function PowerStreamDetail() {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();

    return (
        <div className={`${styles.powerStreamDetail} powerStreamDetail`}>
            {locale === 'de' && <HeaderSticky />}
            <FirstKv />
            <PageCom />
        </div>
    );
}
